module.exports = __webpack_public_path__ + "img/eye.0aaf788c.svg";